// extracted by mini-css-extract-plugin
export default {"logo":"BlueLogo__logo___FmcqZ"};